import { useDispatch, useSelector } from "react-redux";

import { ActionSectionIcons } from "AssortmentOverview/ProductSection/Header/ActionSection/types";
import { ProductListRow } from "ProductList/types";
import { ProductSectionView } from "AssortmentOverview/ProductSection/types";
import { useActiveLayout } from "Workspace/ActiveLayout";

import { ProductSectionState, RowSelectionData } from "./store";
import { actions } from "./slice";

const useProductSectionState = () => {
  const {
    setActiveView,
    toggleDoorsModal,
    toggleImportModal,
    enableDeleteProducts,
    enableWorkspaceAssistant,
    setDisabledAction,
    setEnabledAction,
    setRowsDeleted,
    setSelectedRows,
    setNewStyleColorRows,
  } = actions;
  const [activeLayout, setActiveLayout] = useActiveLayout();

  const dispatch = useDispatch();
  const productSectionState = useSelector<
    ProductSectionState,
    ProductSectionState["productSection"]
  >((state) => state.productSection);
  return {
    toggleImportModal: () => dispatch(toggleImportModal()),
    shouldShowImportModal: productSectionState.shouldShowImportModal,
    toggleDoorsModal: () => dispatch(toggleDoorsModal()),
    shouldShowDoorsModal: productSectionState.shouldShowDoorsModal,
    setActiveView: (view: ProductSectionView) => {
      dispatch(setActiveView(view));
      setActiveLayout(view);
    },
    activeView: activeLayout,
    setDisabledAction: (payload: ActionSectionIcons) =>
      dispatch(setDisabledAction(payload)),
    setEnabledAction: (payload: ActionSectionIcons) =>
      dispatch(setEnabledAction(payload)),
    disabledActions: productSectionState.disabledActions,
    enableDeleteProducts: (payload: boolean) =>
      dispatch(enableDeleteProducts(payload)),
    deleteProductsEnabled: productSectionState.deleteProductsEnabled,
    setSelectedRows: (payload: RowSelectionData[]) =>
      dispatch(setSelectedRows(payload)),
    selectedRows: productSectionState.selectedRows,
    rowsDeleted: productSectionState.rowsDeleted,
    setRowsDeleted: (payload: any[]) => dispatch(setRowsDeleted(payload)),
    newStyleColorRows: productSectionState.newStyleColorRows,
    setNewStyleColorRows: (payload: ProductListRow[]) =>
      dispatch(setNewStyleColorRows(payload)),
    enableWorkspaceAssistant: (payload: boolean) =>
      dispatch(enableWorkspaceAssistant(payload)),
    workspaceAssistantEnabled: productSectionState.workspaceAssistantEnabled,
  };
};

export default useProductSectionState;
